import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useScrollReveal from '../../../hooks/useScrollReveal';
import windmillBanner from '../../../assets/windmill banner.jpg';
import windmillImg    from '../../../assets/windmill.jpg';
import './windmill.css';

// ✅ NEW windmill assets
const windRotorMain = require('../../../assets/windmill/rotor size dia 5m height 1 (1).jpeg');
const windRotor2    = require('../../../assets/windmill/rotor size dia 5m height 1 (2).jpeg');
const windRotor3    = require('../../../assets/windmill/rotor size dia 5m height 1 (3).jpeg');
const windRotor4    = require('../../../assets/windmill/rotor size dia 5m height 1 (4).jpeg');
const windStator1   = require('../../../assets/windmill/stateor size 2.7m dia  1.5m height  (1).jpeg');
const windStator2   = require('../../../assets/windmill/stateor size 2.7m dia  1.5m height  (2).jpeg');
const windBottomCyl = require('../../../assets/windmill/bottom cylinder assemply.jpeg');
const windTormel    = require('../../../assets/windmill/tormel gummiert size 1.6m dia 1.2m height.jpeg');
const windmill27    = require('../../../assets/windmill/windmill (27).jpeg');

const CAPABILITIES = [
  {
    title: 'Stator Components',
    desc: 'Precision-manufactured stator components engineered to meet stringent dimensional and quality requirements for wind turbine generator applications.',
  },
  {
    title: 'Rotor Housings',
    desc: 'Heavy-duty rotor housings fabricated and machined for accurate alignment, structural strength, and long-term operational reliability.',
  },
  {
    title: 'CNC Machining',
    desc: 'Advanced CNC machining capabilities for large and complex wind energy components, ensuring high accuracy and consistent quality.',
  },
  {
    title: 'Heavy Fabrication',
    desc: 'Specialized fabrication services for critical wind turbine structures using proven welding and manufacturing processes.',
  },
  {
    title: 'Assembly Solutions',
    desc: 'Complete assembly support for wind energy components with strict adherence to customer specifications and industry standards.',
  },
  {
    title: 'Surface Treatment & Finishing',
    desc: 'Professional surface preparation, painting, and finishing services to enhance durability and provide long-term corrosion protection.',
  },
];

// ✅ NEW windmill products with correct new pics
const WM_PRODUCTS = [
  {
    id: 12,
    name: 'Rotor — Dia 5m',
    tag: 'Renewable Energy',
    img: windRotorMain,
    desc: 'Precision-machined rotor (Ø 5000mm, Height 1m) for wind turbines — manufactured on our KOLB Gantry and BERTHIEZ VTL.',
  },
  {
    id: 12,
    name: 'Rotor — Dia 5m',
    tag: 'Renewable Energy',
    img: windRotor2,
    desc: 'Heavy-duty rotor components with tight dimensional accuracy for wind energy applications.',
  },
  {
    id: 15,
    name: 'Stator — Dia 2.7m',
    tag: 'Renewable Energy',
    img: windStator1,
    desc: 'Stator (Ø 2700mm, Height 1.5m) — manufactured to stringent quality requirements for wind turbine generator applications.',
  },
  {
    id: 15,
    name: 'Stator — Dia 2.7m',
    tag: 'Renewable Energy',
    img: windStator2,
    desc: 'Precision stator components verified against customer specifications under full ISO quality control.',
  },
  {
    id: 16,
    name: 'Bottom Cylinder Assembly',
    tag: 'Renewable Energy',
    img: windBottomCyl,
    desc: 'Heavy-duty bottom cylinder assembly fabricated and machined for structural strength and long-term operational reliability.',
  },
  {
    id: 17,
    name: 'Tormel Gummiert — Dia 1.6m',
    tag: 'Renewable Energy',
    img: windTormel,
    desc: 'Tormel gummiert (Ø 1600mm, Height 1.2m) — precision-machined wind turbine component with strict quality adherence.',
  },
  {
    id: 12,
    name: 'Rotor Component',
    tag: 'Renewable Energy',
    img: windRotor3,
    desc: 'Large-scale rotor assemblies fabricated and machined under full ISO quality control.',
  },
  {
    id: 18,
    name: 'Windmill Component',
    tag: 'Renewable Energy',
    img: windmill27,
    desc: 'Precision CNC-machined windmill structural component for high accuracy and consistent quality.',
  },
  {
    id: 12,
    name: 'Rotor — Top View',
    tag: 'Renewable Energy',
    img: windRotor4,
    desc: 'Rotor top-view — all components verified against customer specifications with full dimensional traceability.',
  },
];

export default function Windmill() {
  const bodyRef = useScrollReveal();
  const capRef  = useScrollReveal();
  const prodRef = useScrollReveal();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="windmill-page">

      {/* ── HERO BANNER ── */}
      <section className="wm-hero">
        <img src={windmillBanner} alt="Windmill Components" className="wm-hero__img" />
        <div className="wm-hero__overlay" />
        <div className="container wm-hero__content">
          <div className="wm-hero__tag">
            <span className="wm-hero__tag-dot" />
            Renewable Energy · Heavy Machining
          </div>
          <h1 className="wm-hero__title">
            Windmill<br/>
            <span className="wm-hero__title-accent">Components</span>
          </h1>
          <p className="wm-hero__sub">
            Large-scale structural fabrication and precision machining for India's growing wind energy sector.
            Manufactured on our 12.5m KOLB Gantry and BERTHIEZ 8.2m VTL.
          </p>
          <div className="wm-hero__pills">
            <span className="wm-hero__pill">KOLB Gantry 12.5m</span>
            <span className="wm-hero__pill">BERTHIEZ VTL 8.2m</span>
            <span className="wm-hero__pill">Heavy Fabrication</span>
            <span className="wm-hero__pill">ISO 9001:2015</span>
          </div>
        </div>
        <div className="wm-hero__wave">
          <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="var(--bg)"/>
          </svg>
        </div>
      </section>

      {/* ── INTRO SECTION ── */}
      <section className="section bg-white" ref={bodyRef}>
        <div className="container">
          <div className="wm-intro-grid">
            <div className="reveal from-left">
              <h2 className="section-title wm-serif-heading">
                Precision Parts for<br/>
                <span className="text-emerald">Clean Energy</span>
              </h2>
              <div className="line-red" style={{ background: '#10B981' }} />
              <p className="section-sub">
                MILLTECH CNC has been supplying precision-machined components to windmill manufacturers
                for over a decade. Our heavy-duty machining infrastructure — including the KOLB Gantry at
                12.5m X-travel and the BERTHIEZ 8.2m VTL — is purpose-built for large renewable energy parts.
              </p>
              <p className="section-sub">
                We manufacture Rotors, Stators, cooling unit pipe lines, structural tanks, hub flanges, nacelle bed plates, and
                trolley systems. Every component is fabricated and machined under strict quality control with
                full dimensional traceability.
              </p>
              <div className="wm-stats">
                <div className="wm-stat">
                  <span className="wm-stat__val">12.5m</span>
                  <span className="wm-stat__label">KOLB Gantry X-Axis</span>
                </div>
                <div className="wm-stat">
                  <span className="wm-stat__val">100T</span>
                  <span className="wm-stat__label">Max Load Capacity</span>
                </div>
                <div className="wm-stat">
                  <span className="wm-stat__val">Ø 8.2m</span>
                  <span className="wm-stat__label">VTL Swing Diameter</span>
                </div>
              </div>
              <Link to="/contact" className="btn btn-indigo" style={{ marginTop: '2rem' }}>
                Request Windmill Quote →
              </Link>
            </div>
            <div className="wm-intro-img reveal from-right">
              <img src={windmillImg} alt="Windmill manufacturing" />
            </div>
          </div>
        </div>
      </section>

      {/* ── WINDMILL PRODUCTS ── */}
      <section className="section bg-white wm-products-section" ref={prodRef}>
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            Product Gallery
          </h2>
          <div className="wm-prod-grid">
            {WM_PRODUCTS.map((p, i) => (
              <div key={i} className="wm-prod-card reveal" style={{ transitionDelay: `${i * 0.08}s` }}>
                <div className="wm-prod-card__img-wrap">
                  <img src={p.img} alt={p.name} className="wm-prod-card__img"
                    style={{ objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%' }} />
                  <span className="wm-prod-card__tag">{p.tag}</span>
                </div>
                <div className="wm-prod-card__body">
                  <h3 className="wm-prod-card__name">{p.name}</h3>
                  <p className="wm-prod-card__desc">{p.desc}</p>
                  <Link to={`/products/${p.id}`} className="wm-prod-card__btn">
                    View Details →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CAPABILITIES ── */}
      <section className="section" ref={capRef} style={{ background: 'var(--bg-3)' }}>
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '1rem' }}>
            Wind Energy Capabilities
          </h2>
          <p className="section-sub" style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto 3rem' }}>
            Supporting the renewable energy sector through precision machining, heavy fabrication, and reliable manufacturing solutions for critical wind turbine components.
          </p>
          <div className="wm-cap-grid stagger">
            {CAPABILITIES.map((c, i) => (
              <div key={i} className="wm-cap-card reveal">
                <div className="wm-cap-card__accent" />
                <h3 className="wm-cap-card__title">{c.title}</h3>
                <p className="wm-cap-card__desc">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="wm-cta">
        <div className="container wm-cta__inner">
          <div>
            <h2 className="wm-cta__title">Windmill Component Requirements?</h2>
            <p className="wm-cta__sub">Share your drawings — our engineers respond within 24 hours.</p>
          </div>
          <Link to="/contact" className="btn btn-primary">Contact Us</Link>
        </div>
      </section>

    </main>
  );
}